<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        :size="50"
        color="primary"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="foreignCitation"
        @save="saveForeignCitation"
      />

      <v-row class="mb-0 mt-3">
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-list
            ref="workList"
            class="pr-2 pt-0 transparent overflow-auto"
          >
            <ForeignCitationCard
              :selected-item.sync="foreignCitation"
              :is-show-mode="isShowMode"
              @updateInvalid="updateForeignCitationInvalid"
            />

            <AuthorsCard
              class="mt-4"
              :selected-item.sync="foreignCitation.commonWork.authors"
              :is-show-mode="isShowMode"
              @updateInvalid="updateAuthorsInvalid"
            />

            <CommentCard
              v-if="Boolean(foreignCitation.commonWork.comment)"
              class="mt-4"
              :comment="foreignCitation.commonWork.comment"
            />
          </v-list>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { foreignCitationApi } from '@/api'
import { ForeignCitation } from '../../models'
import TitleCard from '@/components/Works/elements/TitleCard'
import ForeignCitationCard from '../../components/Works/ForeignCitation/ForeignCitationCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { workListHeight } from '@/mixins/workListHeight'
import { mapActions } from 'vuex'
import { workMode } from '@/scripts/consts'

export default {
  name: 'ForeignCitationParent',

  metaInfo: {
    title: 'Иностранное цитирование'
  },

  components: {
    CommentCard,
    AuthorsCard,
    ForeignCitationCard,
    TitleCard
  },

  mixins: [workListHeight],

  async created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    await this.getDictionaries(['magazine'])
    await this.getForeignCitation()
    this.dataLoaded = true
  },

  data: () => ({
    foreignCitation: new ForeignCitation(),
    selectedItem: null,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    saveBtnLoading: false,
    dataLoaded: false,
    foreignCitationInvalid: false,
    authorsInvalid: false
  }),

  computed: {
    invalid() {
      return this.authorsInvalid || this.foreignCitationInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),

    async getForeignCitation() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = await foreignCitationApi.get(this.$route.params?.id)
          this.foreignCitation = new ForeignCitation(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveForeignCitation() {
      try {
        this.saveBtnLoading = true

        if (!this.foreignCitation.id)
          this.foreignCitation.commonWork.workType = { id: 10, name: 'Иностранное цитирование' }

        const data = this.foreignCitation.id
          ? await foreignCitationApi.update(this.foreignCitation.getForAPI())
          : await foreignCitationApi.create(this.foreignCitation.getForAPI())

        if (!this.foreignCitation.id) await this.$router.replace('/works/foreignCitation/edit/' + data.id)

        this.foreignCitation = new ForeignCitation(data)
        this.$toast.info('Успешно сохранено')
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async updateAuthorsInvalid(val) {
      this.authorsInvalid = val
    },

    async updateForeignCitationInvalid(val) {
      this.foreignCitationInvalid = val
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  }
}
</script>

<style scoped></style>
